/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1MarkPayoutPaidPayload
 */
export interface V1MarkPayoutPaidPayload {
    /**
     * Where the transfer can be checked (tx hash, ...)
     */
    note?: string
}

/**
 * Check if a given object implements the V1MarkPayoutPaidPayload interface.
 */
export function instanceOfV1MarkPayoutPaidPayload(
    value: object
): value is V1MarkPayoutPaidPayload {
    return true
}

export function V1MarkPayoutPaidPayloadFromJSON(
    json: any
): V1MarkPayoutPaidPayload {
    return V1MarkPayoutPaidPayloadFromJSONTyped(json, false)
}

export function V1MarkPayoutPaidPayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1MarkPayoutPaidPayload {
    if (json == null) {
        return json
    }
    return {
        note: json['note'] == null ? undefined : json['note']
    }
}

export function V1MarkPayoutPaidPayloadToJSON(
    json: any
): V1MarkPayoutPaidPayload {
    return V1MarkPayoutPaidPayloadToJSONTyped(json, false)
}

export function V1MarkPayoutPaidPayloadToJSONTyped(
    value?: V1MarkPayoutPaidPayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        note: value['note']
    }
}
